import React from "react";
import "./TopBar.scss";
import { FaSquareInstagram } from "react-icons/fa6";
import { FaFacebookF } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa";
import { IoLogoYoutube } from "react-icons/io5";
import { FaPhoneAlt } from "react-icons/fa";
import { IoIosMailUnread } from "react-icons/io";

const TopBar = () => {
  return (
    <div className="topbar">
      <div className="social-link">
        <div className="othercontainer">
          <a href="#">
            <FaSquareInstagram />
          </a>
        </div>
        <div className="line"></div>
        <div className="othercontainer">
          <a href="#">
            <FaFacebookF />
          </a>
        </div>
        <div className="line"></div>
        <div className="othercontainer">
          <a href="#">
            <FaLinkedinIn />
          </a>
        </div>
        <div className="line"></div>
        <div className="othercontainer">
          <a href="#">
            <IoLogoYoutube />
          </a>
        </div>
        <div className="line"></div>
        <div className="othercontainer">
          <a href="tel:+14164777692">
            <FaPhoneAlt />
          </a>
        </div>
        <div className="line"></div>
        <div className="othercontainer">
          <a href="mailto:sales@argussecurity.ca">
            <IoIosMailUnread />
          </a>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
